var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSelect',_vm._b({attrs:{"readonly":_vm.appIsMobile,"options":_vm.regions,"label-key":"name","value-key":"id","placeholder":_vm.$t('players.region_select')},model:{value:(_vm.regionId),callback:function ($$v) {_vm.regionId=$$v},expression:"regionId"}},'BaseSelect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }